import { render, staticRenderFns } from "./charge-sms-wallet-manually.vue?vue&type=template&id=35420543&scoped=true"
import script from "./charge-sms-wallet-manually.vue?vue&type=script&lang=js"
export * from "./charge-sms-wallet-manually.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35420543",
  null
  
)

export default component.exports